interface RuntimeConfig {
  VITE_API_BASE_URL: string;
  VITE_OIDC_CLIENT_ID?: string;
  VITE_OIDC_AUTHORITY?: string;
  VITE_OIDC_REDIRECT_URI?: string;
  VITE_OIDC_POST_LOGOUT_REDIRECT_URI?: string;
}

declare global {
  interface Window {
    runtimeConfig: RuntimeConfig;
  }
}

const getApiBaseUrl = (): string => {
  if (window.runtimeConfig && window.runtimeConfig.VITE_API_BASE_URL) {
    return window.runtimeConfig.VITE_API_BASE_URL;
  }

  // Fallback for local development if config.js is not present
  const envUrl = import.meta.env.VITE_API_BASE_URL;

  if (envUrl) {
    return envUrl;
  }

  return "http://localhost:8080";
};

export const apiConfig = {
  baseUrl: getApiBaseUrl(),
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
} as const;

export type ApiConfig = typeof apiConfig;
